<template>
    <div>
        <div
            v-if="alertMessage"
            class="alert trial-alert-expiry alert-dismissible fade show"
            :class="alertColor"
            role="alert"
        >
            <div class="alert-message" v-html="alertMessage"></div>
            <a v-if="!inBillingProfilePage" @click.prevent="redirectUser" class="trial-upgrade-btn">
                {{ $t('pages.dashboardLayout.upgradeNow') }}
            </a>
        </div>
        <div v-if="licenseMessage" class="alert trial-alert-expiry alert-danger" role="alert">
            {{ licenseMessage }}
            <MailToSupport />
            {{ licenseMessagePart2 }}
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import MailToSupport from './MailToSupport';

export default {
    name: 'TrialBanner',
    components: { MailToSupport },
    mixins: [GeneralMixin],
    data() {
        return {
            trialDaysLeft: 0,
            trialAlertColor: 'alert-primary',
            hasStripeCustomerId: true,
            hideBannerRoles: ['Customer', 'Customer Admin']
        };
    },
    computed: {
        ...mapGetters({
            isTrialExpired: 'user/isTrialExpired',
            user: 'user/user',
            teamStatus: 'team/teamStatus'
        }),
        inBillingProfilePage() {
            return this.$route.name === 'Billing Profile';
        },
        license() {
            return this.user.license ?? {};
        },
        licenseMessage() {
            if (this.hideBannerRoles.includes(this.user.role)) 
                return '';

            if (this.license.status === 'Trial') 
                return '';

            if (
                !this.user.hasTeam ||
                !this.license ||
                !this.license.isLicenseCheckEnabled ||
                this.license.hasEnoughLicense
            )
                return '';

            return `You currently have ${this.license.activeUser} active users of ${
                this.license.licensedUser
            } licenses. Please `;
        },
        licenseMessagePart2() {
            if (this.hideBannerRoles.includes(this.user.role)) 
                return '';

            if (!this.user.hasTeam || !this.license || this.license.hasEnoughLicense) 
                return '';

            return ` to upgrade.`;
        },
        alertMessage() {
            if (this.hideBannerRoles.includes(this.user.role)) 
                return '';

            if (!this.license || !this.license.status || this.license.status === 'Disabling') {
                return this.$t('pages.dashboardLayout.accountStatusDisabling');
            }

            if (this.license.status === 'Disabled') {
                return this.$t('pages.dashboardLayout.accountStatusDisabled');
            }

            if (this.license.status === 'Trial') {
                if (this.trialDaysLeft <= 0) {
                    return this.$t('pages.dashboardLayout.trialExpired');
                }

                return this.$tc('pages.dashboardLayout.remainingDays', this.trialDaysLeft);
            }

            return '';
        },
        alertColor() {
            if (this.license.status === 'Trial') {
                if (this.trialDaysLeft <= 3) {
                    return 'alert-warning';
                }

                if (this.trialDaysLeft <= 0) {
                    return 'alert-danger';
                }
            } else if (
                !this.license ||
                !this.license.status ||
                this.license.status === 'Disabling' ||
                this.license.status === 'Disabled'
            ) {
                return 'alert-danger';
            }

            return 'alert-primary';
        }
    },
    mounted() {
        const trialEnd = this.license.trialEnd || moment();
        const today = moment().startOf('day');
        const expiryDate = moment(trialEnd);
        this.trialDaysLeft = expiryDate.diff(today, 'days');
    },
    methods: {
        async redirectUser() {
            this.$router.push({ name: 'Billing Profile' });
        }
    }
};
</script>

<style lang="scss" scoped>
.main-panel-whitebg {
    background-color: #fff;
    > .content {
        padding-top: 0;
    }

    .trial-upgrade-btn {
        margin-left: 20px;
        cursor: pointer;
    }
}

.custom-lp {
    position: relative;
    .trial-alert-container {
        position: sticky;
        top: 0;
        z-index: 999;
        .trial-alert-expiry {
            width: 100%;
            text-align: center;
            margin-bottom: 0;
            span {
                max-width: 100%;
                display: inline-block;
            }

            a {
                color: white;
            }
        }
        .trial-upgrade-btn {
            color: #fff;
            border: 2px solid #fff;
            padding: 5px 10px;
            margin-left: 20px;
            cursor: pointer;
        }

        .trial-upgrade-btn:hover,
        .trial-upgrade-btn:focus,
        .trial-upgrade-btn:active {
            color: #fff !important;
        }

        .alert-message {
            display: inline !important;
        }
    }
}
</style>
